var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
    },
    [
      _c("fieldset", { staticClass: "form__group" }, [
        _c("legend", [_vm._v("Confirm the information below")]),
        _vm._v(" "),
        _c("h2", { staticClass: "h3" }, [_vm._v(_vm._s(_vm.resource.name))]),
        _vm._v(" "),
        _vm.resource.logo
          ? _c("img", {
              attrs: { src: `/images/logo/${_vm.resource.id}`, alt: "Logo" },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "post-details" }, [
          _vm.resource.region
            ? _c("div", { staticClass: "detail" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Region covered"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.hq
            ? _c("div", { staticClass: "detail" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v("Company HQ Location"),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "h3" },
                  [
                    _c("SvgIcon", { attrs: { icon: "location" } }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.resource.hq.location) +
                        ", " +
                        _vm._s(_vm.resource.hq.country.name) +
                        "\n\t\t\t\t"
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resource.offices && _vm.resource.offices.length
            ? _c(
                "div",
                { staticClass: "detail" },
                [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Additional company office location(s)"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.resource.offices, function (office) {
                    return _c(
                      "span",
                      { staticClass: "h3" },
                      [
                        _c("SvgIcon", { attrs: { icon: "location" } }),
                        _vm._v(
                          " " +
                            _vm._s(office.location) +
                            ", " +
                            _vm._s(office.country.name) +
                            "\n\t\t\t\t"
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__group form__group--submit" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "wait",
                  rawName: "v-wait:disabled",
                  value: ["submit"],
                  expression: '["submit"]',
                  arg: "disabled",
                },
              ],
              staticClass: "btn",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.back.apply(null, arguments)
                },
              },
            },
            [_vm._v("Back")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "wait",
                  rawName: "v-wait:disabled",
                  value: ["submit"],
                  expression: '["submit"]',
                  arg: "disabled",
                },
              ],
              staticClass: "btn btn--primary",
            },
            [_vm._v("Create Users")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }